import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API, startSignIn } from "./auth";

function readParam(name) {
  // The provider returns /erp?state=...#session_id=...  — look in BOTH query and hash.
  const search = window.location.search || "";
  const hash = (window.location.hash || "").replace(/^#/, "");
  const fromSearch = new URLSearchParams(search).get(name);
  if (fromSearch) return fromSearch;
  const fromHash = new URLSearchParams(hash).get(name);
  return fromHash || null;
}

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = readParam("session_id");
    const state = readParam("state");
    const run = async () => {
      if (!sessionId) {
        setError("Sign-in could not be completed. No session was returned.");
        return;
      }
      try {
        const response = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId, state }),
        });
        let result = {};
        try { result = await response.json(); } catch (e) { /* ignore */ }
        if (!response.ok) {
          // Surface the server's message (these never contain tokens).
          throw new Error(result.error || "We couldn't verify your sign-in. Please try again.");
        }
        window.history.replaceState(null, "", "/erp");
        navigate("/erp", { replace: true });
      } catch (e) {
        setError(e instanceof Error ? e.message : "We couldn't verify your sign-in. Please try again.");
      }
    };
    void run();
  }, [navigate]);

  return (
    <div className="erp-loading" data-testid="auth-callback">
      <div className="loading-brand">R<span>E</span></div>
      {!error ? (
        <>
          <div className="loading-spinner" />
          <h2>Signing you in</h2>
          <p>Verifying your Rollcon workspace access…</p>
        </>
      ) : (
        <>
          <h2>Sign-in interrupted</h2>
          <p data-testid="auth-callback-error">{error}</p>
          <div className="button-row">
            <button className="erp-button primary" onClick={() => void startSignIn()} data-testid="auth-callback-retry">Try again</button>
            <a className="erp-button secondary" href="/" data-testid="auth-callback-home">Back to welcome</a>
          </div>
        </>
      )}
    </div>
  );
}
